/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".dicom-header-subtitle[_ngcontent-%COMP%]{color:var(--clr-color-neutral-600,#666);margin:0 0 .5rem}.dicom-header-filter[_ngcontent-%COMP%]{width:100%;margin-bottom:.5rem}.dicom-header-table-scroll[_ngcontent-%COMP%]{max-height:60vh;overflow-y:auto}.dicom-header-mono[_ngcontent-%COMP%]{font-family:monospace;white-space:nowrap}.dicom-header-loading[_ngcontent-%COMP%]{display:flex;align-items:center;padding:1rem 0}.dicom-header-loading[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]{margin-right:.5rem}.dicom-header-empty[_ngcontent-%COMP%]{padding:1rem 0;color:var(--clr-color-neutral-600,#666)}"];
export { styles as styles };

